/**
 * O cabeçalho que só existe no papel do Fechamento.
 *
 * Papel: reproduz `.print-header` (l. 563–574): à esquerda o monograma, o
 * filete, o wordmark e "Dashboard de Fechamento" em latão; à direita a caixa
 * "Mês de referência" com o mês, de borda de cima latão; tudo com o filete
 * embaixo e 12 px + 14 px de respiro.
 *
 * Como usar: a `AbaFechamento` o põe no alto do relatório. Na tela ele não
 * aparece; no papel, só com a marca `imprimindo-fechamento` no `<body>` — um
 * Ctrl+P comum não o mostra. Os dois logotipos são os da `BarraDoApp`,
 * extraídos da origem para `public/marca/`; trocar o arquivo lá exigirá trocar
 * aqui também.
 */

/** Monograma da origem, o mesmo da `BarraDoApp`. */
const MONOGRAMA = '/marca/villa-prado-monograma-origem.jpg';

/** Wordmark da origem, o mesmo da `BarraDoApp`. */
const WORDMARK = '/marca/villa-prado-wordmark-origem.png';

/**
 * O cabeçalho do papel.
 *
 * @param rotulo - O mês aberto, como `MAR 2026`.
 * @returns O cabeçalho, escondido fora da impressão do Fechamento.
 */
export function CabecalhoDeImpressao({ rotulo }: { rotulo: string }) {
  return (
    <div className="mb-3.5 hidden items-center justify-between border-b border-emb-borda pb-3 print:[body[data-impressao=imprimindo-fechamento]_&]:flex">
      <div className="mr-2 flex items-center gap-3">
        <img src={MONOGRAMA} alt="Villa Prado" className="h-10 rounded-[3px]" />
        <div aria-hidden="true" className="h-7 w-px shrink-0 bg-emb-borda" />
        <img src={WORDMARK} alt="Villa Prado" className="h-6 w-auto object-contain" />
        <div className="font-outfit text-[11px] tracking-[0.08em] text-brass uppercase">
          Dashboard de Fechamento
        </div>
      </div>
      <div className="rounded-emb border border-t-[3px] border-emb-borda border-t-brass bg-superficie px-[18px] py-2 text-center">
        <div className="mb-1 font-mono text-[9px] tracking-[0.7px] text-texto-fraco uppercase">
          Mês de referência
        </div>
        <div className="font-outfit text-[17px] font-light tracking-[0.5px] text-foreground">
          {rotulo}
        </div>
      </div>
    </div>
  );
}
